define('models/composer/forms/QuestionType',{
    multipleChoice: 'multipleChoiceQuestion'
});

